// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================
   Dashboard Skeleton Layout Styles
   Mirrors the exact sizing and spacing of the real dashboard
   ========================================================= */

/* ── KPI box (top-right of Strategy Distribution header)
       Mirrors real .strategy-box: display:flex row, padding:20px 25px ── */
.skl-kpi-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 20px 25px;
  border: 1px solid #e9ecef;
  border-left: 3px solid #0066B2;
  border-radius: 6px;
  background: #f8f9fa;
  min-width: 140px;
  white-space: nowrap;
}

/* Force card-header to 78px (matches measured Strategy Distribution header) */
.skl-strategy-header {
  min-height: 78px;
  box-sizing: border-box;
}

/* ── Strategy KPI grid (4 columns) ── */
.strategy-boxes-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.skl-strategy-card {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 18px 16px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

/* ── Blue card header ── */
.skl-blue-header {
  background: #0066B2 !important;
  border-bottom: none !important;
  border-top-left-radius: 12px !important;
  border-top-right-radius: 12px !important;
  min-height: 44px;
  display: flex;
  align-items: center;
}

/* Override shimmer gradient inside blue header for contrast */
.skl-blue-header .skl-header-bar app-skeleton .skeleton-block,
.skl-header-bar ::ng-deep .skeleton-block {
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.25) 25%,
    rgba(255, 255, 255, 0.45) 50%,
    rgba(255, 255, 255, 0.25) 75%
  ) !important;
  background-size: 200% 100% !important;
}

/* ── Table skeleton ── */
.skl-table-wrap {
  padding: 0;
}

.skl-table-head-row {
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #dee2e6;
  background: #f8f9fa;
  min-height: 65px;
}

.skl-table-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px;
  align-items: start;
  padding: 10px 16px;
  border-bottom: 1px solid #f0f0f0;
  min-height: 60px;
}

.skl-table-row app-skeleton {
  display: block;
}

/* ── Donut footer ── */
.skl-donut-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.skl-donut-stats {
  min-width: 85px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.skl-stat-row {
  display: flex;
  align-items: baseline;
  gap: 6px;
}

.skl-donut-circle-wrap {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.skl-donut-circle {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: conic-gradient(#e9ecef 0deg, #e9ecef 360deg);
  position: relative;
}

/* Inner cut-out to mimic donut shape */
.skl-donut-circle::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 66px;
  height: 66px;
  border-radius: 50%;
  background: #f8f9fa;
}

.skl-donut-legend {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-left: auto;
}

.skl-legend-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.skl-legend-dot {
  display: inline-block;
  width: 11px;
  height: 11px;
  border-radius: 2px;
  background: #e9ecef;
  flex-shrink: 0;
}

/* ── Responsive ── */
@media (max-width: 1199.98px) {
  .skl-donut-circle-wrap {
    flex: 0 0 auto;
  }

  .skl-donut-circle {
    width: 100px;
    height: 100px;
  }

  .skl-donut-circle::after {
    width: 56px;
    height: 56px;
  }
}

@media (max-width: 767.98px) {
  .strategy-boxes-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .skl-donut-circle {
    width: 80px;
    height: 80px;
  }

  .skl-donut-circle::after {
    width: 44px;
    height: 44px;
  }
}
`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/dashboard/dashboard-skeleton/dashboard-skeleton.component.css"],"names":[],"mappings":"AAAA;;;8DAG8D;;AAE9D;2EAC2E;AAC3E;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,8EAA8E;AAC9E;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA,2BAA2B;AAC3B;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,uCAAuC;EACvC,wCAAwC;EACxC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA,8DAA8D;AAC9D;;EAEE;;;;;cAKY;EACZ,qCAAqC;AACvC;;AAEA,yBAAyB;AACzB;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,wDAAwD;EACxD,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* =========================================================\n   Dashboard Skeleton Layout Styles\n   Mirrors the exact sizing and spacing of the real dashboard\n   ========================================================= */\n\n/* ── KPI box (top-right of Strategy Distribution header)\n       Mirrors real .strategy-box: display:flex row, padding:20px 25px ── */\n.skl-kpi-box {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  padding: 20px 25px;\n  border: 1px solid #e9ecef;\n  border-left: 3px solid #0066B2;\n  border-radius: 6px;\n  background: #f8f9fa;\n  min-width: 140px;\n  white-space: nowrap;\n}\n\n/* Force card-header to 78px (matches measured Strategy Distribution header) */\n.skl-strategy-header {\n  min-height: 78px;\n  box-sizing: border-box;\n}\n\n/* ── Strategy KPI grid (4 columns) ── */\n.strategy-boxes-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.skl-strategy-card {\n  background: #ffffff;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 18px 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n/* ── Blue card header ── */\n.skl-blue-header {\n  background: #0066B2 !important;\n  border-bottom: none !important;\n  border-top-left-radius: 12px !important;\n  border-top-right-radius: 12px !important;\n  min-height: 44px;\n  display: flex;\n  align-items: center;\n}\n\n/* Override shimmer gradient inside blue header for contrast */\n.skl-blue-header .skl-header-bar app-skeleton .skeleton-block,\n.skl-header-bar ::ng-deep .skeleton-block {\n  background: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0.25) 25%,\n    rgba(255, 255, 255, 0.45) 50%,\n    rgba(255, 255, 255, 0.25) 75%\n  ) !important;\n  background-size: 200% 100% !important;\n}\n\n/* ── Table skeleton ── */\n.skl-table-wrap {\n  padding: 0;\n}\n\n.skl-table-head-row {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  padding: 12px 16px;\n  border-bottom: 1px solid #dee2e6;\n  background: #f8f9fa;\n  min-height: 65px;\n}\n\n.skl-table-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 8px;\n  align-items: start;\n  padding: 10px 16px;\n  border-bottom: 1px solid #f0f0f0;\n  min-height: 60px;\n}\n\n.skl-table-row app-skeleton {\n  display: block;\n}\n\n/* ── Donut footer ── */\n.skl-donut-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.skl-donut-stats {\n  min-width: 85px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.skl-stat-row {\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n}\n\n.skl-donut-circle-wrap {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.skl-donut-circle {\n  width: 120px;\n  height: 120px;\n  border-radius: 50%;\n  background: conic-gradient(#e9ecef 0deg, #e9ecef 360deg);\n  position: relative;\n}\n\n/* Inner cut-out to mimic donut shape */\n.skl-donut-circle::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 66px;\n  height: 66px;\n  border-radius: 50%;\n  background: #f8f9fa;\n}\n\n.skl-donut-legend {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-left: auto;\n}\n\n.skl-legend-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.skl-legend-dot {\n  display: inline-block;\n  width: 11px;\n  height: 11px;\n  border-radius: 2px;\n  background: #e9ecef;\n  flex-shrink: 0;\n}\n\n/* ── Responsive ── */\n@media (max-width: 1199.98px) {\n  .skl-donut-circle-wrap {\n    flex: 0 0 auto;\n  }\n\n  .skl-donut-circle {\n    width: 100px;\n    height: 100px;\n  }\n\n  .skl-donut-circle::after {\n    width: 56px;\n    height: 56px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .strategy-boxes-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .skl-donut-circle {\n    width: 80px;\n    height: 80px;\n  }\n\n  .skl-donut-circle::after {\n    width: 44px;\n    height: 44px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
